import React from "react";
import Select from "react-select";

import { useTranslation } from "react-i18next";

import { getLabel } from "../../utils/languageUtils";
import { useLanguage } from "../../context/LanguageContext";

export default function MultiSelectField({

    label,
    options = [],
    value = [],
    optionValue = "id",

    optionLabel = "",

    field = "",

    onChange,
    onAdd,
    onRemove,

    isDisabled = false

}) {

    // ==========================================================
    // Traduction
    // ==========================================================

    const { t } = useTranslation();

    // ==========================================================
    // Langue courante
    // ==========================================================

    const { language } = useLanguage();

    // ==========================================================
    // Styles
    // ==========================================================

    const customStyles = {

        control: (provided, state) => ({

            ...provided,

            minHeight: 46,

            borderRadius: 10,

            cursor: isDisabled
                ? "not-allowed"
                : "default"

        }),

        menuPortal: (provided) => ({

            ...provided,

            zIndex: 99999

        }),

        menu: (provided) => ({

            ...provided,

            zIndex: 99999

        })

    };

    // ==========================================================
    // Libellé d'une option
    // ==========================================================

    const getOptionLabel = (option) => {

        if (!option) {

            return "";

        }

        // ------------------------------------------------------
        // Cas 1 :
        //
        // optionLabel={(a) =>
        //     getLabel(a, "activityProf", language)
        // }
        // ------------------------------------------------------

        if (typeof optionLabel === "function") {

            const labelResult =
                optionLabel(option);

            return labelResult ?? "";

        }

        // ------------------------------------------------------
        // Cas 2 :
        //
        // optionLabel="activityProf"
        // ------------------------------------------------------

        if (
            typeof optionLabel === "string" &&
            optionLabel
        ) {

            return (

                getLabel(
                    option,
                    optionLabel,
                    language
                ) ?? ""

            );

        }

        // ------------------------------------------------------
        // Cas 3 :
        //
        // Ancienne propriété "field"
        // ------------------------------------------------------

        if (
            typeof field === "string" &&
            field
        ) {

            return (

                getLabel(
                    option,
                    field,
                    language
                ) ?? ""

            );

        }

        // ------------------------------------------------------
        // Sécurité
        // ------------------------------------------------------

        return "";

    };

    // ==========================================================
    // Valeur de l'option
    // ==========================================================

    const getOptionValue = (option) => {

        if (!option) {

            return "";

        }

        const optionValueResult =
            option[optionValue];

        return (
            optionValueResult !== undefined &&
            optionValueResult !== null
        )
            ? String(optionValueResult)
            : "";

    };

    // ==========================================================
    // Changement de sélection
    // ==========================================================

    const handleChange = (
        selected,
        actionMeta
    ) => {

        const selectedValues =
            selected ?? [];

        // ------------------------------------------------------
        // Callback général
        // ------------------------------------------------------

        if (onChange) {

            onChange(selectedValues);

        }

        // ------------------------------------------------------
        // Gestion des événements
        // ------------------------------------------------------

        switch (actionMeta.action) {

            case "select-option":

                if (
                    onAdd &&
                    actionMeta.option
                ) {

                    onAdd(
                        actionMeta.option
                    );

                }

                break;

            case "remove-value":

                if (
                    onRemove &&
                    actionMeta.removedValue
                ) {

                    onRemove(
                        actionMeta.removedValue
                    );

                }

                break;

            case "pop-value":

                if (
                    onRemove &&
                    actionMeta.removedValue
                ) {

                    onRemove(
                        actionMeta.removedValue
                    );

                }

                break;

            default:

                break;

        }

    };

    // ==========================================================
    // Rendu
    // ==========================================================

    return (

        <div className="mb-3">

            {/* ==================================================
                LABEL
            ================================================== */}

            {label && (

                <label className="form-label fw-bold">

                    {label}

                </label>

            )}

            {/* ==================================================
                SELECT
            ================================================== */}

            <Select

                isMulti

                options={options}

                value={value}

                isDisabled={isDisabled}

                styles={customStyles}

                menuPortalTarget={document.body}

                menuPosition="fixed"

                closeMenuOnSelect={false}

                hideSelectedOptions={false}

                getOptionValue={
                    getOptionValue
                }

                getOptionLabel={
                    getOptionLabel
                }

                onChange={
                    handleChange
                }

                // ------------------------------------------------
                // Placeholder traduit
                // ------------------------------------------------

                placeholder={
                    t("common.select")
                }

                // ------------------------------------------------
                // Aucune option
                // ------------------------------------------------

                noOptionsMessage={() =>
                    t("common.noOptions")
                }

                // ------------------------------------------------
                // Recherche sans résultat
                // ------------------------------------------------
                loadingMessage={() =>
                    t("common.loading")
                }

            />
        </div>
    );
}